/**
 * Label for the locked user-type field on edit.
 * Uses the role catalog when it contains the assigned type, and the user's
 * stored role name when that catalog is unavailable.
 */

/**
 * @param {Array<{ value: string, label: string }>|null|undefined} roles
 * @param {string|number|null|undefined} tipoDeUsuario
 * @param {string|null|undefined} nombreRol
 * @returns {{ value: string, label: string }|null}
 */
export const selectedEditableRole = (roles, tipoDeUsuario, nombreRol) => {
  if (tipoDeUsuario == null || tipoDeUsuario === "") {
    return null;
  }
  const match = (Array.isArray(roles) ? roles : []).find(
    (role) => String(role.value) === String(tipoDeUsuario),
  );
  if (match) {
    return match;
  }
  const label = typeof nombreRol === "string" ? nombreRol.trim() : "";
  if (!label) {
    return null;
  }
  return { value: String(tipoDeUsuario), label };
};

/**
 * Keeps the assigned role visible when it is missing from the catalog options.
 * @param {Array<{ value: string, label: string }>|null|undefined} roles
 * @param {string|number|null|undefined} tipoDeUsuario
 * @param {string|null|undefined} nombreRol
 * @returns {Array<{ value: string, label: string }>}
 */
export const rolesWithAssignedRole = (roles, tipoDeUsuario, nombreRol) => {
  const list = Array.isArray(roles) ? roles : [];
  const selected = selectedEditableRole(list, tipoDeUsuario, nombreRol);
  if (!selected) {
    return list;
  }
  if (list.some((role) => String(role.value) === selected.value)) {
    return list;
  }
  return [selected, ...list];
};
